export const iconFontAwesomeSecurityBuildingLock = (
	<i className="fa-solid fa-building-lock"></i>
);
